var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mt-header',{staticClass:"navheader",attrs:{"title":_vm.title}},[_c('div',{attrs:{"slot":"right"},on:{"click":_vm.home},slot:"right"},[_c('img',{staticClass:"icon",attrs:{"src":require("../static/image/shouye.png"),"alt":""}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80ec7f2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigator.vue
// module id = null
// module chunks = 